export default __webpack_public_path__ + "static/media/Resume-2.6e976796.pdf";